import { CommonEnums } from '../../common.enums'

export class Looper_End {
    looper_End_Id: number;
    looper_Id: number;
    dxFlow_Id: number;
    nm: string;
    updateDt: Date;
    updateBy: string;
    valid_Cd: string;
    looper_StartNm: string;
    disableFlg: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.looper_End_Id = CommonEnums.defaults.LONG_VAL;
        this.looper_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.looper_StartNm = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_EMPTY;
    }
    
    static parse(looper_EndTmp: Looper_End): Looper_End {
        let looper_End: Looper_End = new Looper_End();
        looper_End.copyFrom(looper_EndTmp);
        return looper_End;
    }

    copy(): Looper_End {
        let looper_EndTmp: Looper_End = new Looper_End();

        looper_EndTmp.looper_End_Id = this.looper_End_Id;
        looper_EndTmp.looper_Id = this.looper_Id;
        looper_EndTmp.dxFlow_Id = this.dxFlow_Id;
        looper_EndTmp.nm = this.nm;
        looper_EndTmp.updateDt = this.updateDt;
        looper_EndTmp.updateBy = this.updateBy;
        looper_EndTmp.valid_Cd = this.valid_Cd;
        looper_EndTmp.looper_StartNm = this.looper_StartNm;
        looper_EndTmp.disableFlg = this.disableFlg;

        return looper_EndTmp;
    }

    copyFrom(looper_EndTmp: Looper_End): void {
        this.looper_End_Id = looper_EndTmp.looper_End_Id;
        this.looper_Id = looper_EndTmp.looper_Id;
        this.dxFlow_Id = looper_EndTmp.dxFlow_Id;
        this.nm = looper_EndTmp.nm;
        this.updateDt = looper_EndTmp.updateDt;
        this.updateBy = looper_EndTmp.updateBy;
        this.valid_Cd = looper_EndTmp.valid_Cd;
        this.looper_StartNm = looper_EndTmp.looper_StartNm;
        this.disableFlg = looper_EndTmp.disableFlg;
    }

    compare(looper_EndTmp: Looper_End): string {
        let looper_EndString: string = this.toString(false);
        let looper_EndTmpString: string = looper_EndTmp.toString(false);

        if (looper_EndString != looper_EndTmpString) {
            return looper_EndString + ', ' + looper_EndTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Looper_End [looper_End_Id=" + this.looper_End_Id + ", looper_Id=" + this.looper_Id +
            ", dxFlow_Id=" + this.dxFlow_Id + ", nm=" + this.nm + 
             ", disableFlg=" + this.disableFlg;

        if (isNotCompare) {
            str += ", looper_StartNm=" + this.looper_StartNm +
            ", valid_Cd=" + this.valid_Cd+
            ", updateDt =" + this.updateDt + ", updateBy=" + this.updateBy;
        }

        str += ']';
        return str;
    }
}